var map = {
	"./a11y-labels.json": 787,
	"./all-star.json": 788,
	"./alter-ego.json": 789,
	"./art-prize/2019.json": 790,
	"./art-prize/2020.json": 791,
	"./art-prize/global.json": 792,
	"./auth.json": 793,
	"./beginners-series.json": 794,
	"./careers-position.json": 795,
	"./careers.json": 796,
	"./faq.json": 797,
	"./footer.json": 798,
	"./global.json": 799,
	"./handbook.json": 800,
	"./home.json": 801,
	"./ipad-3d.json": 802,
	"./ipad-a11y.json": 803,
	"./ipad-brushes.json": 804,
	"./ipad-color.json": 805,
	"./ipad-superpowers.json": 806,
	"./ipad-video.json": 807,
	"./ipad-whats-new.json": 808,
	"./ipad.json": 809,
	"./meta.json": 810,
	"./navigation.json": 811,
	"./pocket-whats-new.json": 812,
	"./pocket.json": 813,
	"./press.json": 814,
	"./prize.json": 815,
	"./sitemap.json": 816,
	"./support.json": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;